import AbstractRequestTask from '../AbstractRequestTask';
import Launcher from '../../apa/Launcher';
import Utils from '../../../utils/Utils';
import { ENABLE_MODAL_RETRIES } from '../../RequestManagerConstants';
import Constants from 'src/AAF/Ads/Constans';
class CampaignTask extends AbstractRequestTask {
    constructor(group_id, payway_token) {
        super();
        this.body = { payway_token, output: Constants.OUTPUT_CAMPAIGN_SERVICE };
        this.group_id = group_id;
    }

    getParams() {
        return this.body;
    }

    getUrl() {
        const url = this.forceMwfkUrl ? this.forceMwfkUrl : Launcher.get('akamai_mfwk');
        return `${url}/services/campaign/v1/${this.group_id}?${this.getQueryStringParams()}`;
    }

    getMethod() {
        return 'POST';
    }

    getHeaders() {
        const params = super.getParams();
        const user_token = params.user_token;

        return {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${user_token}`,
        };
    }

    getEncType() {
        return 'application/json';
    }

    getQueryStringParams() {
        const params = super.getParams();

        const paramsRequest = {
            device_type: params.device_type,
            device_model: params.device_model,
            device_manufacturer: params.device_manufacturer,
            device_category: params.device_category,
            region: params.region,
            authpt: params.authpt,
            authpn: params.authpn,
            device_id: params.device_id,
            device_so: params.device_so,
        };

        return Utils.buildQueryParams(paramsRequest);
    }

    getShowErrorModal() {
        return ENABLE_MODAL_RETRIES;
    }
}

export default CampaignTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/ads/CampaignTask.js